import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-20 justify-between" }
const _hoisted_2 = { class: "absolute left-1/2 top-1/2 block w-5 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_3 = { class: "grow" }
const _hoisted_4 = { class: "flex" }

import {
  onMounted,
  ref,
  watch,
} from 'vue';
import MemberMenu from '@/components/NavBar/MemberMenu.vue';
import NavLogoWithText from '@/components/NavBar/NavLogoWithText.vue';
import ToggleTheme from '@/components/NavBar/ToggleTheme.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardHeader',
  setup(__props) {


const appStore = useStore.app;
const navStore = useStore.nav;

// const toggleLight = ref(false);

// watch(() => toggleLight.value, () => {
//   navStore.toggleTheme();
// });

watch(() => appStore.device.isMobile, (isMobile) => {
  navStore.isDashboardSidebarOpen = !isMobile;
});

onMounted(() => {
  const { isMobile } = appStore.device;
  navStore.isDashboardSidebarOpen = !isMobile;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("button", {
      class: "relative h-10 w-10 focus:outline-none",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(navStore).toggleDashboardSidebar && _unref(navStore).toggleDashboardSidebar(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          "aria-hidden": "true",
          class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", {
            'rotate-45': _unref(navStore).isDashboardSidebarOpen,
            '-translate-y-1.5': !_unref(navStore).isDashboardSidebarOpen,
          }])
        }, null, 2),
        _createElementVNode("span", {
          "aria-hidden": "true",
          class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", { 'opacity-0': _unref(navStore).isDashboardSidebarOpen }])
        }, null, 2),
        _createElementVNode("span", {
          "aria-hidden": "true",
          class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", {
            '-rotate-45': _unref(navStore).isDashboardSidebarOpen,
            'translate-y-1.5': !_unref(navStore).isDashboardSidebarOpen,
          }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(NavLogoWithText, {
        class: _normalizeClass(["lg:transition-all lg:duration-500 lg:ease-in-out", {
          'lg:ml-[calc(50%-40px)]': !_unref(navStore).isDashboardSidebarOpen,
          'lg:ml-4': _unref(navStore).isDashboardSidebarOpen,
        }])
      }, null, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(MemberMenu)
    ])
  ]))
}
}

})